import { useEffect, useRef, useState, type Dispatch, type SetStateAction, type default as React } from 'react';

import { Grid, Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { SearchButton, SelectCustomer, SelectCenter } from 'components/commonparts'

import type { GetMstTransportRelationTransportRelationGetRequest } from 'api-client'

interface SearchConditionProps {
  searchParam: GetMstTransportRelationTransportRelationGetRequest
  onSearch: (requestParam: GetMstTransportRelationTransportRelationGetRequest) => void
  hasDataEdited: boolean  // 編集中のデータがあるか？
  setDiscardChangeDialogOpen: Dispatch<SetStateAction<boolean>>,
  searchTrigger?: boolean // 親コンポーネントから検索実行された場合に値が変化する
}

function SearchCondition({
  searchParam, 
  onSearch, 
  hasDataEdited=false,
  setDiscardChangeDialogOpen,
  searchTrigger,
}: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()

  const [orgCenterId, setOrgCenterId] = useState<string | null | undefined>(searchParam.orgCenterId)
  const [orgCustomerId, setOrgCustomerId] = useState<string | null | undefined>(searchParam.orgCustomerId)

  const onSearchClick=()=>{
    if (hasDataEdited) {
      setDiscardChangeDialogOpen((prev) => !prev)
      return
    }

    onSearch({
      companyId: loginUserInfo!.companyId,
      orgCenterId,
      orgCustomerId,
      enabled: false,
    })  
  }

  const isFirstSearchTriggerEffect = useRef(true)
  useEffect(() => {
    // 初回マウントで親の初期 fetch と二重に /transport-relation が呼ばれるのを防ぐ
    if (isFirstSearchTriggerEffect.current) {
      isFirstSearchTriggerEffect.current = false
      return
    }
    // searchTriggerの変更を検知して、検索イベントを起こす
    // 親コンポーネントなどで検索を行いたい場合は、このトリガーを使用する
    onSearch({
      companyId: loginUserInfo!.companyId,
      orgCenterId,
      orgCustomerId,
      enabled: false,
    })   
  }, [searchTrigger])

  return (
        <Grid container>
            <SelectCenter
              trCompanyId={searchParam.companyId}
              orgCenterId={orgCenterId}
              setOrgCenterId={setOrgCenterId}
              setCenterInfo={() => {}}
              isRequired={false}
              setIsValid={() => {}}
              enabled={false}
            />
            <SelectCustomer 
              trCompanyId={searchParam.companyId}
              orgCustomerId={orgCustomerId}
              setOrgCustomerId={setOrgCustomerId}
              setCustomerInfo={() => {}}
              isRequired={false}
              setIsValid={() => {}}
            />
          <Box display="flex" justifyContent="center" alignItems="end" marginBottom='5px' marginRight='10px'>
              <SearchButton searchId="item" onSearchClick={onSearchClick}/>
          </Box>
        </Grid>
  )
}

export default SearchCondition
